// test1455
(1455 && 0);
